import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_MENU_DETAILS, EDIT_MENU } from './constants';

export const getMenuDetails = extendRoutine(createRoutine(GET_MENU_DETAILS), 'RESET');

export const editMenu = extendRoutine(createRoutine(EDIT_MENU), 'RESET');
